import React, { ReactNode } from "react"
import Spacer, { SpacerVariant } from "../layout/spacer"

import { BackgroundColor } from "../layout"
import { Icons } from "../../../types/icons"
import classNames from "classnames"
import { useTranslation } from "react-i18next"

interface SliderNavigationProps {
    lastIndex: number
    length: number
    goTo: (index: number) => void
    bgColor?: BackgroundColor
    hideBullets?: boolean
    footnotes?: ReactNode
}

const SliderNavigation = ({ lastIndex, length, goTo, bgColor, hideBullets, footnotes }: SliderNavigationProps) => {
    const { t } = useTranslation("translations")

    return (
        <div>
            <Spacer variant={SpacerVariant.Small} />
            <div
                className={classNames(
                    "flex h-full",
                    footnotes
                        ? "flex-col gap-y-6 sm:flex-row sm:items-start sm:gap-x-8"
                        : "items-center justify-center sm:justify-end"
                )}
            >
                {footnotes && <div className="w-full sm:min-w-0 sm:flex-1">{footnotes}</div>}
                <div
                    className={classNames(
                        "items-center justify-center sm:flex sm:justify-end",
                        hideBullets ? "hidden" : "flex",
                        footnotes && "w-full sm:w-auto sm:shrink-0"
                    )}
                >
                    <button
                        className={classNames(
                            "mr-3.5 hidden select-none sm:block lg:mr-5",
                            bgColor === BackgroundColor.White || bgColor === BackgroundColor.Grey
                                ? "text-blue"
                                : "text-white",
                            { "pointer-events-none opacity-30": lastIndex < 1 }
                        )}
                        type="button"
                        onClick={() => goTo(lastIndex - 1)}
                        disabled={lastIndex < 1}
                        aria-label={t("slider_previous")}
                    >
                        <i className="lavita-icon text-[42px] lg:text-[52px]">{Icons.back}</i>
                    </button>
                    <button
                        className={classNames(
                            "hidden select-none sm:block",
                            bgColor === BackgroundColor.White || bgColor === BackgroundColor.Grey
                                ? "text-blue"
                                : "text-white",
                            { "pointer-events-none opacity-30": lastIndex + 1 >= length }
                        )}
                        type="button"
                        onClick={() => goTo(lastIndex + 1)}
                        disabled={lastIndex + 1 >= length}
                        aria-label={t("slider_next")}
                    >
                        <i className="lavita-icon scale-x-[-1] text-[42px] lg:text-[52px]">{Icons.back}</i>
                    </button>
                    {!hideBullets &&
                        [...Array(length)].map((_, i) => (
                            <button
                                type="button"
                                className={classNames(
                                    "mr-1.5 h-[9px] w-[9px] rounded-full last:mr-0 sm:hidden",
                                    bgColor === BackgroundColor.White || bgColor === BackgroundColor.Grey
                                        ? "bg-blue"
                                        : "bg-white",
                                    { "opacity-30": lastIndex !== i }
                                )}
                                onClick={() => goTo(i)}
                                key={i}
                                aria-label={t("slider_item") + (i + 1)}
                            ></button>
                        ))}
                </div>
            </div>
        </div>
    )
}

export default SliderNavigation
